module.exports = __webpack_public_path__ + "static/media/check-mark-blue.2a2fbc53.svg";